import React from "react";

import {Stack} from "react-bootstrap";

import clsx from "clsx";

interface LomavisTableTitle1Props {
    children: React.ReactNode;
    className?: string;
}

/**
* Atoms: LomavisTableTitle1
*/
export const LomavisTableTitle1: React.FC<LomavisTableTitle1Props> = ({  children, className  }) => {
    return (
        <Stack className={clsx("fs-4 fw-bold", className)}>
            {children}
        </Stack>
    );
};